/* global axios */
import ApiClient from './ApiClient';

class ProductCategoriesAPI extends ApiClient {
  constructor() {
    super('product_categories', { accountScoped: true });
  }

  create(data) {
    // Si c'est FormData, utiliser axios directement (sans définir Content-Type, le navigateur le fait automatiquement)
    if (data instanceof FormData) {
      return axios.post(this.url, data);
    }
    // Sinon, utiliser la méthode parente
    return super.create(data);
  }

  update(id, data) {
    // Si c'est FormData, utiliser axios directement (sans définir Content-Type, le navigateur le fait automatiquement)
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data);
    }
    // Sinon, utiliser la méthode parente
    return super.update(id, data);
  }
}

export default new ProductCategoriesAPI();
